/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/',
    name: 'Dashboard',
    view: 'Dashboard'
  },
  {
    path: '/video',
    name: 'Video',
    view: 'Video'
  },
  {
    path: '/exercise',
    name: 'Exercise',
    view: 'Exercise'
  }
]
